import { IS_STNET } from '@utils/Constants'
import { InvoiceData } from 'src/models/Invoice'
import { UserData } from 'src/models/User'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getBillingAmountGuide
 */

type GetBillingAmountGuideParams = {
  userId: number
  year: number
  month: number
}

type GetBillingAmountGuideResponseData = {
  billingAmountGuide: number | null
}

export const getBillingAmountGuide = async ({ userId, ...rest }: GetBillingAmountGuideParams) => {
  return await get<GetBillingAmountGuideResponseData>(`/v1/users/${userId}/invoices/billingAmountGuide`, rest)
}

/**
 * getInvoice
 */

type GetInvoiceParams = {
  userId: number
  year: number
  month: number
}

export const getInvoice = async ({ userId, ...rest }: GetInvoiceParams) => {
  return await get<InvoiceData>(`/v1/users/${userId}/invoices/stnet`, rest)
}

/**
 * getInvoiceDates
 */

type GetInvoiceDatesParams = {
  userId: number
}

type GetInvoiceDatesResponseData = {
  dates: string[]
}

export const getInvoiceDates = async ({ userId }: GetInvoiceDatesParams) => {
  const data = await get<GetInvoiceDatesResponseData>(`/v1/users/${userId}/invoices/dates`)
  return data.dates
}

/**
 * getSampleInvoice
 */

export type GetSampleInvoiceParams = {
  token: string
  userCode: string
  year: number
  month: number
}

export type GetSampleInvoiceResponseData = {
  invoice: InvoiceData
  user: UserData
}

export const getSampleInvoice = async (params: GetSampleInvoiceParams) => {
  return await get<GetSampleInvoiceResponseData>(`/v1/users/invoices/sample`, { ...params, isSTNet: IS_STNET }, false)
}
